// extracted by mini-css-extract-plugin
export default {"menuToggle":"l2dws_","toggleOpen":"McKTTM","buttonContainer":"mN90sd","toggleButton":"d6OaiD"};